import { RSAA, RSAAction } from 'redux-api-middleware';

import { AddCertificatePayload, CertificateType } from './certificates.types';
import * as types from './certificatesActionsTypes';

export const fetchCertificates = (
  account: string,
  application: string,
  type: string,
  certificateType: CertificateType,
): RSAAction<string, string, string> => ({
  [RSAA]: {
    endpoint: `company-accounts/${account}/applications/${type}/${application}/certificates/${certificateType}`,
    method: 'GET',
    types: [types.FETCH_CERTIFICATE_REQUEST, types.FETCH_CERTIFICATE_SUCCESS, types.FETCH_CERTIFICATE_FAILURE],
  },
});

export const addCertificate = (
  account: string,
  application: string,
  type: string,
  body: AddCertificatePayload,
): RSAAction<string, string, string> => ({
  [RSAA]: {
    body,
    endpoint: `company-accounts/${account}/applications/${type}/${application}/certificates`,
    method: 'POST',
    types: [types.ADD_CERTIFICATE_REQUEST, types.ADD_CERTIFICATE_SUCCESS, types.ADD_CERTIFICATE_FAILURE],
  },
});
